import { render, staticRenderFns } from "./smart-tags.vue?vue&type=template&id=531ed8d9&scoped=true&"
import script from "./smart-tags.vue?vue&type=script&lang=js&"
export * from "./smart-tags.vue?vue&type=script&lang=js&"
import style0 from "./smart-tags.vue?vue&type=style&index=0&id=531ed8d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ed8d9",
  null
  
)

export default component.exports